'use client';

import { useTranslation } from '@/hook';
import styles from '../../StyledComponents/styles.module.scss';
import colors from '../../../../../theme/colors.module.scss';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { DisplayedCarInfoInterface, Showroom } from '@/types';
import { useState } from 'react';
import ShowroomModal from './ShowroomModal';
import Typography from '@/components/shared/typography/typography.component';
import { LocationIcon } from '../../../../../../public/Images/Icons';
import Image from 'next/image';
import { AVAILABLE_LANGUAGES } from '@/constants';

const ShowroomSection = ({
    showroom,
    lang,
    isDesktop,
    carInfo,
    setNotifyModal,
    seeCarButtonClicked,
}: {
    showroom: Showroom;
    lang: AVAILABLE_LANGUAGES;
    isDesktop: boolean;
    carInfo: DisplayedCarInfoInterface;
    setNotifyModal: React.Dispatch<React.SetStateAction<boolean>>;
    seeCarButtonClicked: () => void;
}) => {
    const { t } = useTranslation();
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <ShowroomModal
                open={modalOpen}
                lang={lang}
                onClose={setModalOpen}
                showroom={showroom}
                isDesktop={isDesktop}
                carInfo={carInfo}
                setNotifyModal={setNotifyModal}
                seeCarButtonClicked={seeCarButtonClicked}
            />
            <div
                className={styles.CarProFileMoreInfoContainer}
                style={{
                    paddingTop: '0px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                    gap: '8px',
                    padding: isDesktop
                        ? '0px 0px 16px 0px'
                        : '16px 0px 16px 0px',
                }}
            >
                <Typography variant="body2Medium" color={colors.gray500}>
                    {t('sylndr showroom')}
                </Typography>
                <div
                    style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-between',
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        setModalOpen(true);
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            gap: '4px',
                            alignItems: 'center',
                            maxWidth: '90%',
                        }}
                    >
                        <Image
                            src={LocationIcon}
                            alt={'otherInfoIcon'}
                            color={colors.primary600}
                            width={20}
                            height={20}
                        />

                        <Typography
                            variant="body1Medium"
                            color={colors.gray700}
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {lang === 'en'
                                ? showroom.address.en
                                : showroom.address.ar}
                        </Typography>
                    </div>
                    {lang === 'en' ? (
                        <ChevronRight
                            sx={{
                                color: colors.primary,
                                width: '24px',
                                height: '24px',
                            }}
                        />
                    ) : (
                        <ChevronLeft
                            sx={{
                                color: colors.primary,
                                width: '24px',
                                height: '24px',
                            }}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default ShowroomSection;
